function notifyCart(t) {
    if (window.ajax_add_to_cart) $("#cart-loading").addClass("is_loading"), $(".product .product-wait").hide(), $(".cart-sidebar").toggleClass("opened"), $("html,body").toggleClass("cart-opened");
    else {
        var a = $("#umbrella"),
            o = (a.offset().top, a.offset().left, $(t));
        $("body").append(o), $(o).hide(), $(o).fadeIn("slow", "easeInOutExpo", function() {
            var t = $(this).offset().top,
                a = $(this).offset().left;
            $(this).css({
                margin: 0,
                left: a,
                top: t,
                position: "absolute"
            }).delay(2e3).animate({
                top: 0,
                left: "auto",
                right: 0,
                opacity: 1
            }, 3e3, "easeInOutExpo", function() {
                $(this).remove(), $(".product .product-wait").hide(), window.location = "/cart"
            })
        })
    }
}

function notifyCartFail(t) {
    var a = $(".cart-menu-icon"),
        o = (a.offset().top, a.offset().left, $(t));
    $("body").append(o), $(o).hide(), $(o).fadeIn("slow", "easeInOutExpo", function() {
        var t = $(this).offset().top,
            a = $(this).offset().left;
        $(this).css({
            margin: 0,
            left: a,
            top: t,
            position: "absolute"
        }).delay(2e3).animate({
            top: 0,
            left: "auto",
            right: 0,
            opacity: 1
        }, 3e3, "easeInOutExpo", function() {
            $(this).remove()
        })
    })
}

function addToCart(t) {
    "undefined" != typeof t && t.preventDefault(), $("#cart-loading").addClass("is_loading");
    var a = $(this);
    a.closest(".product_item").addClass("is_loading");
    var o = a.parents("form");
    if (0 == o.serialize().length) {
        var e = a.parents(".product-information");
        o = e.find("form.product-actions")
    }
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        async: !0,
        data: o.serialize(),
        dataType: "json",
        error: addToCartFail,
        success: addToCartSuccess,
        cache: !1
    })
}

function addToCartSuccess() {
    $.ajax({
        type: "GET",
        url: "/cart.js",
//         async: !0,
//         cache: !1,
        dataType: "json",
        success: function(cart) {
          if( typeof cart != 'object' ) cart = $.parseJSON( cart );

          $(".product_item").removeClass("is_loading");
          var t = '<div class="popupaddcart">Item added to Cart!</div>';
          notifyCart(t), Shopify.getCart(function(t) {
            Shopify.updateCartInfo(t, "cart-info")
          }), jQuery(".quantity").val(1).trigger("blur");
          
          while( cart.items.length > 0 ) {

            item = cart.items.shift();

            if(item.variant_title) {
              console.log('. Item in the cart '+item.variant_title);
              if( item.variant_title.indexOf('Digital')>=0 ) {
                $(".open_popup").css("display", "block");
                $(".only_physical").css("display", "none");
                $(".open_popup").click(function(){
                  $("#popup").css("display", "block");
                });

                $("#close_popup").click(function(){
                  $("#popup").css("display", "none");
                }); 
              }
            }
          }

        }
    });
}

function addToCartFail(t) {
    var a = $.parseJSON(t.responseText),
        o = '<div class="popupaddcart">' + a.description + "</div>";
    $(".product_item").removeClass(".is_loading"), notifyCartFail(o), jQuery(".quantity").val(1).trigger("blur")
}

function searchPlaceholder() {
    Modernizr.input.placeholder || ($("#top-search-input").focus(function() {
        var t = $(this);
        t.val() == t.attr("placeholder") && (t.val(""), t.removeClass("placeholder"))
    }).blur(function() {
        var t = $(this);
        ("" == t.val() || t.val() == t.attr("placeholder")) && (t.addClass("placeholder"), t.val(t.attr("placeholder")))
    }).blur(), $("[placeholder]").parents("form").submit(function() {
        $(this).find("[placeholder]").each(function() {
            var t = $(this);
            t.val() == t.attr("placeholder") && t.val("")
        })
    }))
}! function(t) {
    function a() {}
    for (var o, e = "assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","); o = e.pop();) t[o] = t[o] || a
}(function() {
    try {
        return console.log(), window.console
    } catch (t) {
        return window.console = {}
    }
}());
var GLOBAL = {
        common: {
            init: function() {
                $("html").removeClass("no-js").addClass("js"), searchPlaceholder(), $("body").on("click", ".add-to-cart", addToCart)
            }
        },
        templateIndex: {
            init: function() {}
        },
        templateProduct: {
            init: function() {}
        },
        templateCart: {
            init: function() {}
        }
    },
    UTIL = {
        fire: function(t, a, o) {
            var e = GLOBAL;
            a = void 0 === a ? "init" : a, "" !== t && e[t] && "function" == typeof e[t][a] && e[t][a](o)
        },
        loadEvents: function() {
            var t = document.body.id;
            UTIL.fire("common"), $.each(document.body.className.split(/\s+/), function(a, o) {
                UTIL.fire(o), UTIL.fire(o, t)
            })
        }
    };
$(document).ready(UTIL.loadEvents);